import { render, staticRenderFns } from "./SearchCRS.vue?vue&type=template&id=edbe584a&scoped=true&"
import script from "./SearchCRS.vue?vue&type=script&lang=js&"
export * from "./SearchCRS.vue?vue&type=script&lang=js&"
import style0 from "./SearchCRS.vue?vue&type=style&index=0&id=edbe584a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbe584a",
  null
  
)

export default component.exports